import React, { useEffect } from 'react';
import { FormControl, FormLabel, RadioGroup as MuiRadioGroup, FormControlLabel, Radio, FormHelperText } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: theme.spacing(1.5),

  },
  label: {
    padding: '8px',
    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
    '& .MuiTypography-body1': {
      fontSize: theme.spacing(1.5),
      fontFamily: 'cernMedium',
      marginLeft: 0,
      marginRight: '30px',
    },
  },
}));

export default function RadioGroup(props) {
  const {
    name, label, value, onChange, error = null, items, row, inputRef, id,
  } = props;
  const classes = useStyles();
  const [initialValue, setInitialValue] = React.useState(value);

  const handleChange = (e) => {
    setInitialValue(e?.target?.value);
    return e;
  };

  useEffect(() => {
    setInitialValue(value);
  }, [value]);

  return (
    <FormControl>
      <FormLabel className={classes?.title}>{label}</FormLabel>
      <MuiRadioGroup
        row={row || true}
        name={name}
        value={initialValue}
        onChange={e => onChange(handleChange(e))}
        ref={inputRef}
        id={id}
      >
        {
            items?.map(item => (
              <FormControlLabel
                key={item?.id}
                value={item?.id}
                control={<Radio />}
                label={item?.title}
                className={classes?.label}
                disabled={item?.disabled}
                id={id ? `${id}-${String(item?.id ?? '')?.replace(" ", "-")}` : undefined}
              />
            ))
        }
      </MuiRadioGroup>
      {error && <FormHelperText className="MuiFormHelperText-contained Mui-error MuiFormHelperText-marginDense">{error}</FormHelperText>}
    </FormControl>
  );
}
